import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, moveVariableCategoryValues } from 'store/data/variables';

type HandlerInput = Parameters<typeof moveVariableCategoryValues>[0];

export function useMoveVariableCategoryValues(): Operation<(input: HandlerInput) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(ActionTypes.MOVE_VARIABLE_CATEGORY_VALUES);

	function handler(input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		dispatch(moveVariableCategoryValues(input));
	}

	return [{ loading, error }, handler];
}
